// extracted by mini-css-extract-plugin
export default {"alignCenter":"myStyles_alignCenter__AhulD","footerHeading":"myStyles_footerHeading__DlMTJ","footerItemHeading":"myStyles_footerItemHeading__k-46B"};